<template>
  <div>
    <el-card>
      <editForm
        ref="form"
        :code="code"
        :disabled="disabled"
        @saveOkQuestion="saveOkQuestion"
      />
      <page-table
        ref="pageTable"
        v-if="!isDisabled"
        :code="code"
        :disabled="disabled"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from "./components/edit-form"
import PageTable from "./components/table"
export default {
  components: { EditForm, PageTable },
  props: {
    code: String,
    disabled: Boolean,
    isDisabled: Boolean,
  },
  methods: {
    saveOkQuestion() {
      this.$emit("saveOkQuestion")
    },
  },
}
</script>
